// extracted by mini-css-extract-plugin
export default {"container":"CategoriesPage_container__cBrM8","pageTitle":"CategoriesPage_pageTitle__iAsNR"};